import Feed from "src/modules/pe-basic-module/views/core/Feed"
import SearchLandscape from "../landscape/SearchLandscape"
import { ILand } from "src/modules/pe-fest-module/data/interfaces"
import { IFeedProps } from "src/modules/pe-basic-module/views/core/FeedComponent"
import { Button, Icon, Intent } from "@blueprintjs/core"
import { useState } from "react"
import { ID, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { __ } from "src/libs/utilities"
import { IToposStore, useToposStore } from "../../data/store"
import { ILandFilter, LAND_FILTER_TYPE } from "../../data/interfaces"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"

/* Protopia Ecosystem component */
export interface ILandsRightPanelProps { 
}
const LandsRightPanel = (props: ILandsRightPanelProps): JSX.Element => { 
    const {width} = useScreenSize()
    const landFilter: ILandFilter = useToposStore((state:IToposStore) => state.landFilter) 
    const [paging] = useState( ` meta_relation: "AND" metas: [ { key: "hidden", value_bool: false }, { key: "mine", value: "" } ] `)
    
    const onSelect = (id: ID) => {
        useToposStore.setState({ landFilter: { type:LAND_FILTER_TYPE.LAND, id } })
    }

    return width >= WINDOW_WIDTH.TABLET 
        ?
        <div className={`topos-landscape-panel card overflow-y-auto ${ "open" }`}>
            <SearchLandscape />
            
            <Button 
                minimal={landFilter.id !== "all"} 
                fill 
                large 
                rightIcon="duplicate"  
                key="all" 
                alignText="right" 
                onClick={() => onSelect("all") } 
                intent={  !landFilter.id || landFilter.id === "all" ? Intent.DANGER : Intent.NONE}
            />  
            <Feed
                data_type="Land"
                offset={0} 
                class_name='row'
                containerClassName="w-100"  
                component={ FestivalButton } 
                paging={ paging } 
                topPagiHide
                bottomPagiHide
                params={{
                    col:1,
                    select: landFilter.id,
                    onSelect: onSelect
                }}
            /> 
        </div>
        :
        <></>
}
export default LandsRightPanel

/* Protopia Ecosystem component */
export interface IFestivalButtonProps extends IFeedProps {
    item: ILand
    params: any
}

export const FestivalButton = (props: IFestivalButtonProps): JSX.Element => { 
    const onSelect = () => {
        if(props.params.onSelect) {
            props.params.onSelect(props.item.id)
        }
    }
    return <Button 
        minimal={ props.params.select !== props.item.id } 
        fill 
        large 
        alignText="right" 
        onClick={onSelect}
        intent={ props.params.select === props.item.id ? Intent.DANGER : Intent.NONE}
    >
        <div className={` ${props.item.archived ? "opacity_75 font-weight-thin" : ""} small `} title={ __( props.item.archived ?  "Archived": "Open")}>
            {props.item.name}
            <Icon icon={ props.item.archived ?  "eye-off" : "eye-open"} className="ml-2" size={12}/>
        </div>
    </Button> 
} 